module.exports = __webpack_public_path__ + "img/2.4eb59153.jpg";